/**
 * Modulo usado para registro de sessao em
 * "disco", no caso, salvos no localstorage.
 * Prioriza salvar apenas o token e sessionId,
 * pois são os dados essenciais para verificar
 * se uma sessao e valida ou nao. As demais
 * informacoes de sessao (nome, admin, tags, systemodules)
 * sao hidratadas na store (vuex). A hidratacao
 * e feita no start da aplicacao, onde, caso
 * token e sessao estejam no localstorage busca
 * no servidor os demais dados.
 */

import { setItem, getItem, removeItem } from './localStorage'
import { redirect } from './location'

const keys = {
  AUTH_DATA: 'auth_data'
}

/**
 * Salva os dados de autenticação do usuario.
 * @param {Object} data Dados da sessao do usuario
 * @param {String} data.token Token JWT autenticado
 * @param {Number} data.sessionId Id da sessao
 */
export function storeSession ({ token, sessionId }) {
  setItem(keys.AUTH_DATA, { token, sessionId })
}

/**
 * @returns {Boolean}
 */
export function isStoredSessionStarted () {
  try {
    const data = getItem(keys.AUTH_DATA, true)
    return data &&
      data.token &&
      data.sessionId
  } catch (e) {
    return false
  }
}

/**
 * @returns {Object}
 */
export function getStoredSession () {
  return getItem(keys.AUTH_DATA, true)
}

/**
 * Limpa a sessao do usuario.
 */
export function removeStoredSession () {
  removeItem(keys.AUTH_DATA)
}

/**
 * Front-end logout. Limpa a stored session
 * sem requisitar o endpoint.
 */
export function rawLogout () {
  removeStoredSession()
  redirect('')
}

/**
 * Atualiza o token da sessao.
 * @param {String} newToken
 */
export function refreshToken (newToken) {
  const session = getStoredSession()
  session.token = newToken
  storeSession(session)
}
